import SeoHead from "@/components/SeoHead";
import Header from "@/components/Header";
import PageBreadcrumb from "@/components/PageBreadcrumb";
import OurStory from "@/components/OurStory";
import TeamSection from "@/components/TeamSection";
import CallToAction from "@/components/CallToAction";
import Footer from "@/components/Footer";

const About = () => {
  return (
    <>
      <SeoHead
        title={{
          en: "About Us | AI-labbet",
          sv: "Om oss | AI-labbet",
        }}
        description={{
          en: "Learn about AI-labbet's mission to help organizations navigate AI transformation with strategy, governance, and education.",
          sv: "Läs om AI-labbets uppdrag att hjälpa organisationer navigera AI-transformation med strategi, styrning och utbildning.",
        }}
        path="/about"
      />
      
      <div className="min-h-screen bg-background flex flex-col">
        <Header />
        <PageBreadcrumb currentPage="about" />
        <main className="flex-1">
          <OurStory />
          <TeamSection />
          <CallToAction />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default About;
